import PasswordResetForm from './ResetPasswordForm';

export default PasswordResetForm;
